import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import Input from '../ui/Input';
import Button from '../ui/Button';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    setTimeout(() => {
      setStatus('success');
      setEmail('');
    }, 1200);
  };

  return (
    <footer className="bg-ink-navy text-white pt-24 pb-8 border-t-8 border-sky-blue mt-20 relative overflow-hidden">
      <div className="absolute top-0 right-0 p-20 opacity-5 pointer-events-none">
        <SafeIcon name="Activity" className="text-[300px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-lemon-yellow rounded-xl flex items-center justify-center border-2 border-white shadow-lg">
                <SafeIcon name="Hexagon" className="text-ink-navy text-xl" />
              </div>
              <span className="font-extrabold text-2xl tracking-tight text-white uppercase italic">
                LittleLab <span className="text-lemon-yellow">STEM</span>
              </span>
            </div>
            <p className="text-slate-400 font-bold leading-relaxed">
              Fostering curiosity and critical thinking through carefully selected, safety-conscious educational experiences.
            </p>
            <div className="flex gap-4">
              {['Facebook', 'Instagram', 'Twitter', 'Youtube'].map(social => (
                <a key={social} href="#" className="w-10 h-10 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center hover:bg-sky-blue hover:border-ink-navy transition-all">
                  <SafeIcon name={social} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-black text-xs uppercase tracking-[0.2em] mb-8 text-sky-blue">Navigation</h4>
            <ul className="space-y-4">
              <li><Link to="/shop" className="text-slate-400 font-bold hover:text-white transition-colors">Shop All Kits</Link></li>
              <li><Link to="/shop?category=bundles" className="text-slate-400 font-bold hover:text-white transition-colors">Lab Bundles</Link></li>
              <li><Link to="/guide" className="text-slate-400 font-bold hover:text-white transition-colors">Parent Guide</Link></li>
              <li><Link to="/faq" className="text-slate-400 font-bold hover:text-white transition-colors">Laboratory Support</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-black text-xs uppercase tracking-[0.2em] mb-8 text-sky-blue">Policies</h4>
            <ul className="space-y-4">
              <li><a href="#" className="text-slate-400 font-bold hover:text-white transition-colors">Shipping Protocol</a></li>
              <li><a href="#" className="text-slate-400 font-bold hover:text-white transition-colors">Returns & Exchanges</a></li>
              <li><a href="#" className="text-slate-400 font-bold hover:text-white transition-colors">Privacy Workspace</a></li>
              <li><a href="#" className="text-slate-400 font-bold hover:text-white transition-colors">Safety Standards</a></li>
            </ul>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-3xl border border-white/10">
            <h4 className="font-black text-xs uppercase tracking-[0.2em] mb-6 text-lemon-yellow">Join the Lab</h4>
            <p className="text-sm font-bold text-slate-300 mb-6">Get weekly experiment ideas and early access to new kit releases.</p>
            
            {status === 'success' ? (
              <div className="bg-emerald-500/20 border border-emerald-500/50 p-4 rounded-xl text-emerald-400 text-sm font-bold flex items-center gap-2">
                <SafeIcon name="CheckCircle" /> Subscribed successfully!
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="space-y-3">
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email coordinates" 
                  className="bg-white/10 border-2 border-white/20 rounded-xl px-4 py-3 w-full text-white placeholder-slate-500 focus:outline-none focus:border-lemon-yellow font-bold transition-all"
                  required
                />
                <Button 
                  type="submit" 
                  className="w-full" 
                  variant="primary"
                  disabled={status === 'loading'}
                >
                  {status === 'loading' ? 'Processing...' : 'Initialize'}
                </Button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-xs font-bold uppercase tracking-widest">
            © {new Date().getFullYear()} LittleLab STEM. Adult supervision required for all projects.
          </p>
        </div>
      </div>
            <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
      </footer>
  );
};

export default Footer;